const API_BASE_URL = (
    process.env.REACT_APP_API_URL ??
    (process.env.NODE_ENV === "development" ? "http://localhost:7053" : "")
).replace(/\/+$/, "");

export const getApiUrl = (path) => {
  if (!path) return API_BASE_URL;

  const cleanedPath = path.replace(/^\/+/, ""); // убираем все ведущие /
  return `${API_BASE_URL}/${cleanedPath}`;
};
